export default __webpack_public_path__ + "static/media/logo-university.9895ea0e.svg";